import { Nullable } from 'common';
import {
  CustomerUsageReport,
  UserCustomer,
  UserUsageReportResult,
} from './models';

export interface UserUsageReportState {
  customers: Nullable<UserCustomer[]>;
  reports: Nullable<CustomerUsageReport[]>;
  searchCriteria: string;
  loading: boolean;
  accessFlag: Nullable<boolean>;
}

export const USER_USAGE_REPORT_CLEAR = 'USER_USAGE_REPORT_CLEAR';
export const USER_USAGE_REPORT_LOADING = 'USER_USAGE_REPORT_LOADING';
export const GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS =
  'GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS';
export const GET_USER_USAGE_REPORTS_SUCCESS = 'GET_USER_USAGE_REPORTS_SUCCESS';
export const GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS =
  'GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS';

interface UserUsageReportClearAction {
  type: typeof USER_USAGE_REPORT_CLEAR;
}

interface UserUsageReportLoadingAction {
  type: typeof USER_USAGE_REPORT_LOADING;
  payload: boolean;
}

export interface GetUserUsageReportCustomersSuccessType {
  type: typeof GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS;
  customers: UserCustomer[];
}

export interface GetUserUsageReportsSuccessType {
  type: typeof GET_USER_USAGE_REPORTS_SUCCESS;
  result: UserUsageReportResult;
}

export interface GetUserUsageReportAccessFlagSuccessType {
  type: typeof GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS;
  accessFlag: boolean;
}

export type UserUsageReportDataActionTypes =
  | UserUsageReportClearAction
  | UserUsageReportLoadingAction
  | GetUserUsageReportCustomersSuccessType
  | GetUserUsageReportsSuccessType
  | GetUserUsageReportAccessFlagSuccessType;
